/**
 * Order timestamp parsing for dashboard duration / stats.
 */

const SQLITE_UTC_RE = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;

export function parseOrderDate(value?: string): Date | null {
  if (!value) return null;

  const trimmed = value.trim();
  if (!trimmed) return null;

  if (trimmed.includes('T')) {
    const parsed = new Date(trimmed);
    return Number.isFinite(parsed.getTime()) ? parsed : null;
  }

  const sqliteMatch = trimmed.match(SQLITE_UTC_RE);
  if (sqliteMatch) {
    const parsed = new Date(
      `${sqliteMatch[1]}-${sqliteMatch[2]}-${sqliteMatch[3]}T${sqliteMatch[4]}:${sqliteMatch[5]}:${sqliteMatch[6]}Z`
    );
    return Number.isFinite(parsed.getTime()) ? parsed : null;
  }

  const match = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):(\d{2}))?/);
  if (match) {
    const [, year, month, day, hour = '0', minute = '0', second = '0'] = match;
    const parsed = new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second)
    );
    return Number.isFinite(parsed.getTime()) ? parsed : null;
  }

  const fallback = new Date(trimmed);
  return Number.isFinite(fallback.getTime()) ? fallback : null;
}

/** Max span included in end-to-end averages (7 days). */
export const MAX_END_TO_END_MS = 7 * 24 * 60 * 60 * 1000;

export function getOrderDurationMinutes(
  placedAt?: string,
  completedAt?: string
): number | null {
  const placed = parseOrderDate(placedAt);
  const completed = parseOrderDate(completedAt);
  if (!placed || !completed) return null;

  const diffMs = completed.getTime() - placed.getTime();
  if (diffMs <= 0 || diffMs > MAX_END_TO_END_MS) return null;

  return diffMs / 60000;
}
